import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import Button from "../button";
import styles from "./style.module.css";

const STEPS = [
  "1. Проверьте в спаме на почте",
  "2. Проверьте, нет ли ошибки в указанной почте",
] as const;

interface EmailNotReceivedModalProps {
  open: boolean;
  onClose: () => void;
  onSupport: () => void;
}

function EmailNotReceivedModal({ open, onClose, onSupport }: EmailNotReceivedModalProps) {
  const [animatedOpen, setAnimatedOpen] = useState(false);

  useEffect(() => {
    if (!open) {
      setAnimatedOpen(false);
      return;
    }
    const frame = requestAnimationFrame(() => setAnimatedOpen(true));
    return () => cancelAnimationFrame(frame);
  }, [open]);

  useEffect(() => {
    if (!open) return;

    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };

    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKeyDown);

    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [open, onClose]);

  if (!open || typeof document === "undefined") return null;

  return createPortal(
    <div
      className={`${styles.overlay} ${animatedOpen ? styles.open : ""}`}
      role="presentation"
      onClick={onClose}
    >
      <div
        className={styles.panel}
        role="dialog"
        aria-modal="true"
        aria-labelledby="email-not-received-title"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 id="email-not-received-title" className={styles.title}>
          Не приходит письмо?
        </h2>
        <ul className={styles.steps}>
          {STEPS.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
        <div className={styles.actions}>
          <Button label="Назад" onClick={onClose} />
          <Button label="Поддержка" variant="secondary" onClick={onSupport} />
        </div>
      </div>
    </div>,
    document.body
  );
}

export default EmailNotReceivedModal;
